import { render, staticRenderFns } from "./项目查询.vue?vue&type=template&id=5df36d9c&scoped=true"
import script from "./项目查询.vue?vue&type=script&lang=js"
export * from "./项目查询.vue?vue&type=script&lang=js"
import style0 from "./项目查询.vue?vue&type=style&index=0&id=5df36d9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df36d9c",
  null
  
)

export default component.exports